import React, { useEffect, useState } from 'react'
import PageTitle from '../../../jsx/layouts/PageTitle';
import ReactPaginate from 'react-paginate';
import { Button } from 'react-bootstrap';
import { getAllSubCategory } from '../../../services/superadminService/SubCategory';
import { Link } from 'react-router-dom';
import { getOrganisationList } from '../../../services/adminApiService/organisationApi/OrganisationApiService';
import { useNavigate } from 'react-router-dom';
import { getIndividaulList } from '../../../services/adminApiService/individualApiService/IndividualAPiService';
import { formatDateTime } from '../../../utils/dateTimeFormate';
import { formatStatus, getStatusColor } from '../../../utils/colorAsperStatus';
import { getVerifieddataList } from '../../../services/adminApiService/verifiedlistApiService/VerifiedLIstApiService';

const VerifiedUserList = ({roletype ,roleCategory}) => {
    console.log("roleCategory",roleCategory);
    const [verifiedUserdataList, setVerifiedUserdataList] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const navigate = useNavigate();

    

    const handleVerificationClick = (id) => {
        navigate(`/verification-view-form/${id}`); // Absolute path
    };

    const getverifiedListApi = async (roletype, perPage,currentPage) => {
        try {
            const response = await getVerifieddataList(roletype,perPage,currentPage);
            // console.log("responseINdividual", response.data.data.data);
            setVerifiedUserdataList(response?.data?.data);
        } catch (error) {
            console.error('Login error:', error);
        }
    };

    useEffect(() => {
        getverifiedListApi(roletype,perPage,currentPage);
    }, [currentPage, perPage]);

    const handlePageChange = (selectedItem) => {
        setCurrentPage(selectedItem.selected);
    };
  return (
    <>
            {/* <PageTitle activeMenu="Table" motherMenu="Post" /> */}
            <div className="col-12">
                <div className="card">
                    <div className="card-header d-flex">
                        <div>
                            <div className="input-group search-area">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search here..."
                                />
                                <span className="input-group-text">
                                    <Link to={"#"}><i className="flaticon-381-search-2"></i></Link>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="w-100 table-responsive">
                            <div id="example_wrapper" className="dataTables_wrapper">
                            <table id="example" className="display w-100 dataTable">
                            <thead>
                                        {roleCategory === "insitute" ? (
                                            <tr>
                                                <th>S.No</th>
                                                <th>Legal Entity</th>
                                                <th>Reg. No</th>
                                                <th>Name of Institution</th>
                                                <th>Contact Person Email</th>
                                                <th>Contact Person Mobile</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        ) : (
                                            <tr>
                                                <th>Sr. No</th>
                                                <th>Reg.Id</th>
                                                <th>Applicant Full Name</th>
                                                <th>Email Id</th>
                                                <th>Contact Number</th>
                                                <th>Registration Date</th>
                                               
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        )}
                                    </thead>
                                    <tbody>
                                        {verifiedUserdataList?.data?.length > 0 ? (
                                            verifiedUserdataList.data.map((data, index) => {
                                                console.log("dataResponse",data?.indivisual?.account_holder_name);
                                                return (
                                                    <tr key={index}>
                                                        {roleCategory === "insitute" ? (
                                                            <>
                                                                <td>{index + 1}</td>
                                                                <td>{data.indivisual?.name_of_legel_entity}</td>
                                                                <td>{data?.registration_number}</td>
                                                                <td>{data?.name_of_organization}</td>
                                                                <td>{data?.created_at}</td>
                                                                <td>{data?.mobile}</td>
                                                                <td style={{ color: getStatusColor(data?.status) }}>
                                                                    {data?.status && formatStatus(data?.status)}
                                                                </td>
                                                                <td>
                                                                    <div className="d-flex">
                                                                        <Button style={{ whiteSpace: 'nowrap' }} onClick={() => handleVerificationClick(data?.id)}> View More </Button>
                                                                        {/* <Button className="btn btn-secondary shadow mx-2" style={{ whiteSpace: 'nowrap' }}> Edit </Button>
                                                                        <Button style={{ whiteSpace: 'nowrap' }} onClick={() => handleVerificationClick(data?.id)}> Verify Application </Button> */}
                                                                    </div>
                                                                </td>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <td>{index + 1}</td>
                                                                <td>{data?.registration_id}</td>
                                                                <td>{data?.first_name}</td>
                                                                <td>{data?.email}</td>
                                                                <td>{data?.indivisual?.mobile}</td>
                                                                <td>{data?.created_at}</td>
                                                                
                                                                <td>
                                                                    <span className="text-succuss">Verified</span>
                                                                </td>
                                                                <td>
                                                                    <div className="d-flex">
                                                                        <Button style={{ whiteSpace: 'nowrap' }} onClick={() => handleVerificationClick(data?.id)}> View More </Button>
                                                                        {/* <Button className="btn btn-secondary shadow mx-2" style={{ whiteSpace: 'nowrap' }}> Edit </Button>
                                                                        <Button style={{ whiteSpace: 'nowrap' }} onClick={() => handleVerificationClick(data?.id)}> Verify Application </Button> */}
                                                                    </div>
                                                                </td>
                                                            </>
                                                        )}
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="9" className="text-center">Data is not available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                    </table>
                            </div>
                        </div>
                    </div>
                </div>
                <ReactPaginate
                    nextLabel="next >"
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={8}
                    marginPagesDisplayed={7}
                    pageCount={Math.ceil(verifiedUserdataList?.data?.total / perPage)}
                    previousLabel="< previous"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                />
            </div>
        </>
  )
}

export default VerifiedUserList